import { TextField, Button } from "@mui/material";
import "./CreatePiForm.css";

export default function CreatePiForm({
  proposedPi,
  setProposedPi,
  onCreate,
  onCancel,
}) {
  return (
    <div
      style={{
        marginTop: 12,
        padding: 12,
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        backgroundColor: "#fafafa",
      }}
    >
      <div style={{ fontSize: 14, marginBottom: 12 }}>
        We could not find this PI in our database. We are going to create it
        with the following data:
      </div>

      <ul style={{ margin: 0, paddingLeft: 18, fontSize: 14 }}>
        <li>
          <b>Name:</b> {proposedPi?.name}
        </li>
        <li>
          <b>Family name:</b> {proposedPi?.familyname}
        </li>
        <li>
          <b>Email:</b> {proposedPi?.email}
        </li>
      </ul>

      <div style={{ marginTop: 12 }}>
        <TextField
          label="ORCID (optional)"
          fullWidth
          size="small"
          value={proposedPi?.orcid || ""}
          onChange={(e) =>
            setProposedPi({
              ...proposedPi,
              orcid: e.target.value,
            })
          }
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
          marginTop: 12,
        }}
      >
        <Button onClick={onCancel}>Cancel</Button>

        <Button variant="contained" onClick={onCreate}>
          Create PI
        </Button>
      </div>
    </div>
  );
}
